module.exports = __webpack_public_path__ + "static/img/bangding.a03b6b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view6/bangding.png
// module id = 4fs6
// module chunks = 1